import { DialogueUIConfig, DialogueUIOptionConfig } from "../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../components/ui/NurseStationComputerUI";
import GameManager from "../cvp-webgames-core/GameManager";
import BaseScenario from "../cvp-webgames-core/Scenario/BaseScenario";
import { constants } from "../misc/constants";
import { KnowledgeCheckUIConfig } from "../components/ui/KnowledgeCheckUI";
import { NurseStationComputerSingleQustionUIConfig } from "../components/ui/NurseStationComputerSingleQuestionUI";
import { getSaveData, setFocus, setUp508 } from "../misc/tools";
import { Windows } from "../pages/MainPage";
import { globals } from "../misc/globals";
import { DelegateUIData } from "../components/ui/DelegateUI";

export enum Window508Type {
    Main,
    ConfirmAlertUI,
    BeginScenarioUI,
    YouRespondUI,
    NurseStationComputerUI,
    NurseStationComputerSingleQuestionUI,
    BadgingProgressUI,
    KnowledgeCheckUI,
    GeneralAlertUI,
    MedicalDispenserUI,
    EndLevelUI,
    DelegateUI,
    StaffingPlanUI,
    AARUI,
}

var current508Window = Window508Type.BeginScenarioUI;
var windows508Layers: any[] = []

const objectWindowIDs = {
    main: {
        objects: [
            // 'main-first-object',
            // 'main-last-object'
            'main-first-object-new',
            'main-last-object-new'
        ]
    },
	ConfirmAlertUI: {
        objects: [
            'confirm-alert-first-object',
            'confirm-alert-last-object'
        ]
    },
    BeginScenarioUI: {
        objects: [
            'begin-scenario-first-object',
            'begin-scenario-first-object'
        ]
    },

    YouRespondUI: {
        objects: [
            'you-respond-first',
            'you-respond-last'
        ]
    },

    NurseStationComputerUI: {
        objects: [
            'nurse-station-computer-first',
            'nurse-station-computer-last'
        ]
    },

    BadgingProgress: {
        objects: [
            'badging-progress-first',
            'badging-progress-bottom'
        ]
    },

    KnowledgeCheck: {
        objects: [
            'knowledge-check-first',
            'knowledge-check-last'
        ]
    },

    NurseStationComputerSingleQuestionUI: {
        objects: [
            'nurse-station-computer-single-question-first',
            'nurse-station-computer-single-question-last'
        ]
    },

    GeneralAlertUI: {
        objects: [
            'general-alert-ui-first',
            'general-alert-ui-last'
        ]
    },

    MedDispenserUI: {
        objects: [
            'med-dispenser-ui-first',
            'med-dispenser-ui-last'
        ]
    },

    EndLevelUI: {
        objects: [
            'end-level-ui-first',
            'end-level-ui-last'
        ]
    },

    DelegateUI: {
        objects: [
            'delegate-ui-first',
            'delegate-ui-last'
        ]
    },

    StaffingPlanUI: {
        objects: [
            'staffing-plan-ui-first',
            'staffing-plan-ui-last'
        ]
    },

    AARUI: {
        objects: [
            'aar-ui-first',
            'aar-ui-last'
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[Window508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };

    windows508Layers[Window508Type.ConfirmAlertUI] = {
        objects: objectWindowIDs.ConfirmAlertUI.objects
    };

    windows508Layers[Window508Type.BeginScenarioUI] = {
        objects: objectWindowIDs.BeginScenarioUI.objects
    };

    windows508Layers[Window508Type.YouRespondUI] = {
        objects: objectWindowIDs.YouRespondUI.objects
    };

    windows508Layers[Window508Type.NurseStationComputerUI] = {
        objects: objectWindowIDs.NurseStationComputerUI.objects
    };

    windows508Layers[Window508Type.NurseStationComputerSingleQuestionUI] = {
        objects: objectWindowIDs.NurseStationComputerSingleQuestionUI.objects
    };

    windows508Layers[Window508Type.BadgingProgressUI] = {
        objects: objectWindowIDs.BadgingProgress.objects
    };

    windows508Layers[Window508Type.KnowledgeCheckUI] = {
        objects: objectWindowIDs.KnowledgeCheck.objects
    };

    windows508Layers[Window508Type.GeneralAlertUI] = {
        objects: objectWindowIDs.GeneralAlertUI.objects
    };

    windows508Layers[Window508Type.MedicalDispenserUI] = {
        objects: objectWindowIDs.MedDispenserUI.objects
    };

    windows508Layers[Window508Type.EndLevelUI] = {
        objects: objectWindowIDs.EndLevelUI.objects
    };

    windows508Layers[Window508Type.DelegateUI] = {
        objects: objectWindowIDs.DelegateUI.objects
    };

    windows508Layers[Window508Type.StaffingPlanUI] = {
        objects: objectWindowIDs.StaffingPlanUI.objects
    };

    windows508Layers[Window508Type.AARUI] = {
        objects: objectWindowIDs.AARUI.objects
    };
}

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

const set508Window = (window: Window508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}


set508Window(Window508Type.Main);

export enum ScoreType {
    Best = 0,
    Ok,
    Zero,
    Worst,
    Worst2
}

export class CalmBaseScenario extends BaseScenario {
    public static scores: number[] = []; //each index is the level part index supplied when calling evaluate answer
    private _staffingPlanScore: number = 0;
    private _delegateUIScore: number = 0;
    private _knowledgeCheckUIScore: number = 0;

    public avatarIndx = 0;

    public static partIndx = 0;

    public audioHall : string = "./assets/audio/general/Hallway_Ambient.mp3";
	public audioRoom : string = "./assets/audio/general/Patient_Room_Ambient.mp3";
	public audioHallToRoom : string = "./assets/audio/general/calm-audio-1_mixdown.mp3";
	public audioRoomToHall : string = "./assets/audio/general/calm-audio-2_mixdown.mp3";
    public audioHasStarted: boolean;
    public ambientLoop: boolean = false;

    public playAudio = (audio: string, loop: boolean, nextAudio?: string) => {        
        this.playSound(audio,() => {                        
        },false,globals.isMuted,true)
              
    }

    public playAmbientLoop = (audio: string, scFour?: boolean) => {        
        if(scFour) {
            this.ambientLoop = false;           
        }

        if(!this.ambientLoop) {
            this.playSound(audio,() => {
                this.playAmbientLoop(audio);
            },false,globals.isMuted,true)
        }
    }

    public stopAmbientLoop = (audio:string) => {
        this.ambientLoop = true;
        this.stopSound(audio)
    }

    public update508Window = (window: Window508Type) => {
        set508Window(window);
    }
    

    public init(onDone: () => void): void {
        if(typeof this.gameManager.customData.saveData.avatarIndx !== 'undefined') {
            this.avatarIndx = this.gameManager.customData.saveData.avatarIndx;
        }
        (window as any).onCaptionsChanged = () => {
            if(this.headerInstanceID) {
                this.gameManager.UiManager.updateUIInstance(this.headerInstanceID);
            }
        }
        onDone();
    }

    public unlockNextLevel() {
        this.gameManager.customData.saveData.scenarios[this.currentLevel + 1].isUnlocked = true;
        this.gameManager.customData.saveGame(this.gameManager);
    }
    private clearProgressExceptBadges() {
        this.gameManager.customData.saveData.scenarios[this.currentLevel].lastPartId = null;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public shouldLoadScenario(): boolean {
		var lastPartId = this.gameManager.customData.saveData.scenarios[this.currentLevel].lastPartId;
        var context = this;
        if(lastPartId) {
            var parts = this.getParts();

            set508Window(Window508Type.ConfirmAlertUI);
            this.gameManager.UiManager.createUIInstance(constants.uiNames.ConfirmAlertUI, {
                onYes: () => {
                    context.destroyAllUIInstances();
                    for(var indx = 0; indx < parts.length - 1; indx++) {
                        if(parts[indx].partId === lastPartId) {
                            //load the next part
                            this.playAmbientLoop(this.audioHall, true);
                            context.loadPart(parts[indx + 1].partId);
                            break;
                        }
                    }
				},
				onNo: () => {
                    context.destroyAllUIInstances();
                    context.clearProgressExceptBadges();
                    window.location.reload();
				},
				text: 'Would you like to resume the level or start over from the beginning?',
				yesBttnText: 'Resume',
				noBttnText: 'Start Over'
            });
            
            
            return true;
        }
        
        return false;
	}

    public get staffingPlanScore() {
        return this._staffingPlanScore;
    }

    public get delegateUIScore() {
        return this._delegateUIScore;
    }

    public get knowledgeCheckUIScore() {
        return this._knowledgeCheckUIScore;
    }

    public set staffingPlanScore(num: number) {
        this._staffingPlanScore = num;
        this.gameManager.customData.saveData.scenarios[this.currentLevel]._staffingPlanScore = this._staffingPlanScore;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public set delegateUIScore(num: number) {
        this._delegateUIScore = num;
        this.gameManager.customData.saveData.scenarios[this.currentLevel]._delegateUIScore = this._delegateUIScore;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public set knowledgeCheckUIScore(num: number) {
        this._knowledgeCheckUIScore = num;
        this.gameManager.customData.saveData.scenarios[this.currentLevel]._knowledgeCheckUIScore = this._knowledgeCheckUIScore;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public static answerAttemptCount: number[] = [];
    constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
        CalmBaseScenario.scores = [];
        CalmBaseScenario.partIndx = 0;
        CalmBaseScenario.answerAttemptCount = [];
	}

    private headerInstanceID: string;

    public get currentLevel(): number {
        throw new Error('currentLevel must be implemented');
    }

    public displayHeader() {
        this.updateObjective('');
    }

    public showKnowledgeCheck(onSubmit: (config?: KnowledgeCheckUIConfig) => void) {
        set508Window(Window508Type.KnowledgeCheckUI);
        this.gameManager.UiManager.createUIInstance(constants.uiNames.KnowledgeCheckUI, {
            title: 'To which report(s) would the following statements be added? Select all that apply.',
            questions: [
                {
                    title: 'An in-patient was accidentally decannulated by a family member. Patient went into cardiac arrest and Medical Emergency Code was activated. Patient was resuscitated and transferred to ICU.',
                    choices: [
                        {
                            title: 'None',
                            isCorrect: false
                        },
                        {
                            title: 'Incident Report',
                            isCorrect: true
                        },
                        {
                            title: 'End of Shift Report',
                            isCorrect: true
                        },
                        {
                            title: '24 Hour Report',
                            isCorrect: true
                        }
                    ]
                },
                {
                    title: 'Patient was discharged without incident (foot infection from Diabetic Neurapathy)',
                    choices: [
                        {
                            title: 'None',
                            isCorrect: false
                        },
                        {
                            title: 'Incident Report',
                            isCorrect: false
                        },
                        {
                            title: 'End of Shift Report',
                            isCorrect: true
                        },
                        {
                            title: '24 Hour Report',
                            isCorrect: true
                        }
                    ]
                },
                {
                    title: 'Interpreter services were used to communicate surgury rationale and obtaining consent.',
                    choices: [
                        {
                            title: 'None',
                            isCorrect: false
                        },
                        {
                            title: 'Incident Report',
                            isCorrect: false
                        },
                        {
                            title: 'End of Shift Report',
                            isCorrect: true
                        },
                        {
                            title: '24 Hour Report',
                            isCorrect: true
                        }
                    ]
                }
            ],
            onSubmit: (config?: KnowledgeCheckUIConfig) => {
                this.knowledgeCheckUIScore = config.score;
                set508Window(Window508Type.Main);
                onSubmit(config);
            }
		})
    }

    public showStaffingPlanUI(onDone: (data?:any) => void) {
        var context = this;
        set508Window(Window508Type.StaffingPlanUI)
        this.gameManager.UiManager.createUIInstance(constants.uiNames.StaffingPlanUI, {
			heatherPatients: 4,
			marcoPatients: 4,
			mirandaPatients: 4,
			benPatients: 5,
			mePatients: 0,
            onDone: (data: any) => {
                set508Window(Window508Type.Main)
                context.staffingPlanScore = data.score;
                onDone(data);
            }
		})
    }

    public showNurseStationComputerForTesting() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
					<p class="regular-description-font" style="margin: 0">
					BLOOD TRANSFUSION POLICY<br />
                    
                        <ul>
                            <li>
                                <span style="color: rgb(222, 225, 156)"> (1) Prep the patient for transfusion</span><br /> <br />
                                <span style="position: relative; left: 14px">A. Check patient consent.</span><br /><br />
                                <span style="position: relative; left: 14px">B. Check patient for patent IV.</span><br /><br />
                            </li>

                            <li>
                                <span style="color: rgb(222, 225, 156)"> (2) Retrieve blood.<br /><br />
                            </li>

                            <li>
                                (3) - (9) : Refer to your local Blood Transfusion Policy<br /><br />
                            </li>
                            
                            <li>
                                (10) Take vital signs after transfusion completed</span><br /><br />
                            </li>
                        </ul>
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
			}
		})
    }

    public showDelegateUIForTesting() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.DelegateUI, {
			cNurseImg: 'ChargeNurse0',
			onContinueClicked: (data: DelegateUIData) => { 
			}			
		})
    }

    public showEndLevelUIForTesting() {
        var level = 3;
		var allBadgesForThisScenario = this.gameManager.customData.saveData.scenarios[level].badges;

        for(var indx = 0; indx < allBadgesForThisScenario.length; indx++) {
            allBadgesForThisScenario[indx].isUnlocked = true;
        }

		var context = this;
		context.gameManager.UiManager.createUIInstance(constants.uiNames.EndLevelUI, {
            level: level,
            badges: allBadgesForThisScenario,
            onExitGameClicked: () => {
            },
            onNextLevelClicked: () => {
            }
        });
    }

    public showBadgingUIForTesting() {
        var badgeToUnlock = this.gameManager.customData.saveData.scenarios[this.currentLevel].badges[0];
		var allBadgesForThisScenario = this.gameManager.customData.saveData.scenarios[3].badges;
		this.gameManager.UiManager.createUIInstance(constants.uiNames.BadgingProgressUI, {
			unlockedBadge: badgeToUnlock,
			allBadges: allBadgesForThisScenario,
			onCloseClicked: () => {
			}
		});
    }

    public showBadgingUI(badgeIndx: number, onDone: () => void) {
        var badgeToUnlock = this.gameManager.customData.saveData.scenarios[this.currentLevel].badges[badgeIndx];
		var allBadgesForThisScenario = this.gameManager.customData.saveData.scenarios[this.currentLevel].badges;
		var context = this;
        set508Window(Window508Type.BadgingProgressUI);
		this.gameManager.UiManager.createUIInstance(constants.uiNames.BadgingProgressUI, {
			unlockedBadge: badgeToUnlock,
			allBadges: allBadgesForThisScenario,
			onCloseClicked: () => {
                set508Window(Window508Type.Main);
                context.destroyAllUIInstances();
				onDone();
			}
		});
    }

    public displayDirections(text: string, img: string, onContinueClicked: () => void, audio?: string, loopAudio?: boolean, isAudioRelative?: boolean) {
        const context = this;
        var canPlay = true;
        if(audio) {
            const playAudio = () => {
                context.playSound(audio + '.mp3', () => {
                    if(loopAudio && canPlay) {
                        playAudio();
                    }
                }, false, globals.isMuted, !isAudioRelative);
            };

            playAudio();
        }

        this.gameManager.UiManager.createUIInstance(constants.uiNames.DirectionsUI, {
            text: text,
            img: img,
            onContinueClicked: () => {
                canPlay = false;
                context.gameManager.SoundManager.stopAllSounds();
                onContinueClicked();
            }
        })
    }

    public updateObjective(objective: string) {
        var context = this;
        if(this.headerInstanceID) {
            this.gameManager.UiManager.updateUIInstance(this.headerInstanceID, {
                objective: objective
            });
        } else {
            this.headerInstanceID = this.gameManager.UiManager.createUIInstance(constants.uiNames.HeaderUI, {
                objective: objective,
                onMainMenuClicked: () => {
                    context.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
                },
                onMainMenuPromptDismissed: () => {
                    context.gameManager.UiManager.showAllUis(null);
                }
            });
        }
    }
    
    public destroyAllUIInstances() {
        this.gameManager.UiManager.destroyAllInstances([constants.uiTags.Hud]);
    }

    public exitGame() {

    }

    public nextLevel() {

    }
    
    public dialog (audio: string, options: DialogueUIOptionConfig[], onOptionSelected: (option: DialogueUIOptionConfig, config?: DialogueUIConfig) => void) {
        var context = this;
        var onDone = () => {
            set508Window(Window508Type.YouRespondUI)
            context.gameManager.UiManager.createUIInstance(constants.uiNames.YouRespondUI, {
                onOptionSelected: onOptionSelected,
                options: options
            });
        }
        
        if(audio) {
            //this.playSound(audio, onDone)
            onDone();
        } else {
            onDone();
        }
    }

    public displayBeginScenarioUI(image: string, audio: string, onDone: () => void) {
        const context = this;
        var instance = '';
        var level = '';
        switch (this.currentLevel) {
            case 0:
            case 1:
            case 2:
            case 3:
                level = 'level ' + (this.currentLevel + 1)
                break;
            case 4:
                level = 'summative'
                break;
            
        }
        
        this.playSound(audio, () => {
            // var uiInstance = context.gameManager.UiManager.getInstanceById(instance);
            // uiInstance.parameters.onCanClick();
        }, false, globals.isMuted);
        set508Window(Window508Type.BeginScenarioUI)
        instance = context.gameManager.UiManager.createUIInstance(constants.uiNames.BeginScenarioUI, {
            image: image,
            text508: `Welcome to charge nurse ${level}. Press enter and your shift as a charge nurse will begin.`,
			onClick: () => {
                context.gameManager.SoundManager.stopAllSounds();
                onDone();
            },
		});
    }

    private _calculateScoring(selectedAnswer: DialogueUIOptionConfig, levelPart: number, isSummative: boolean) {
        if(typeof CalmBaseScenario.scores[levelPart] === 'undefined') {
            CalmBaseScenario.scores[levelPart] = 0;
        }

        if(isSummative) {
            CalmBaseScenario.scores[levelPart] += (selectedAnswer.isCorrect ? 100 : 0);
        } else {
            var updateValues = (best: number, ok: number, zero: number, worst: number, worst2: number) => {
                switch(selectedAnswer.scoreType) {
                    case ScoreType.Best:
                        CalmBaseScenario.scores[levelPart] += best;
                        break;
                    case ScoreType.Ok:
                        CalmBaseScenario.scores[levelPart] += ok;
                        break;
                    case ScoreType.Zero:
                        CalmBaseScenario.scores[levelPart] += zero;
                        break;
                    case ScoreType.Worst:
                        CalmBaseScenario.scores[levelPart] += worst;
                        break;
                    case ScoreType.Worst2:
                        CalmBaseScenario.scores[levelPart] += worst2;
                        break;
                }
            };
            switch(CalmBaseScenario.answerAttemptCount[levelPart]) {
                case 0:
                    updateValues(1000, 250, 0, -100, -500);
                    break;
                case 1:
                    updateValues(500, 100, 0, -100, -500);
                    break;
                case 2:
                    updateValues(250, 0, 0, -100, -500);
                    break;
                default:
                    updateValues(100, 0, 0, -100, -500);
                    break;
            }
        }
        
        this.gameManager.customData.saveData.scenarios[this.currentLevel].scores = CalmBaseScenario.scores;
        // this.gameManager.customData.saveGame(this.gameManager);
    }

    public evaluateAnswer(selectedAnswer: DialogueUIOptionConfig, onCorrect: () => void, levelPart: number, tagExceptions?:string[]): void {
        if(typeof CalmBaseScenario.answerAttemptCount[levelPart] === 'undefined') {
            CalmBaseScenario.answerAttemptCount[levelPart] = 0;
        }
        if(selectedAnswer.isCorrect) {
            this._calculateScoring(selectedAnswer, levelPart, false);
            onCorrect();
        } else {
            CalmBaseScenario.answerAttemptCount[levelPart]++;
            this.gameManager.customData.saveData.scenarios[this.currentLevel].answerAttemptCount = CalmBaseScenario.answerAttemptCount;
            this.gameManager.customData.saveGame(this.gameManager);

            if(tagExceptions) {
                this.showFeedback(selectedAnswer.feedback, () => {
                    selectedAnswer.hide = true;
                },[constants.uiTags.youRespond]);
            } else {
                this.showFeedback(selectedAnswer.feedback, () => {
                    selectedAnswer.hide = true;
                })
            }
        }
    }

    public evaluateAnswer_s (selectedAnswer: DialogueUIOptionConfig, onCorrect: () => void, onIncorrect: () => void): void {
        if(selectedAnswer.isCorrect) {
            onCorrect();
        } else {
            this.showFeedback(selectedAnswer.feedback, () => {
                //selectedAnswer.hide = true;
                onIncorrect();
            });
        }
    }

    public testAar() {
		this.evaluateAnswerForSummative({
            text: '',
            isCorrect: true
        }, {
            onOptionSelected: () => {},
            options: [
                {
                    text: '',
                    isCorrect: false
                },
                {
                    text: '',
                    isCorrect: true
                }
            ],
            aarScenarioID: 0,
            aarSectionID: 0,
            aarCollectionID: [0]
        }, () => {}, 0)

        this.evaluateAnswerForSummative({
            text: '',
            isCorrect: true
        }, {
            onOptionSelected: () => {},
            options: [
                {
                    text: '',
                    isCorrect: true
                },
                {
                    text: '',
                    isCorrect: false
                }
            ],
            aarScenarioID: 0,
            aarSectionID: 1,
            aarCollectionID: [1]
        }, () => {}, 0)

        this.evaluateAnswerForSummative({
            text: '',
            isCorrect: true
        }, {
            onOptionSelected: () => {},
            options: [
                {
                    text: '',
                    isCorrect: true
                },
                {
                    text: '',
                    isCorrect: false
                }
            ],
            aarScenarioID: 0,
            aarSectionID: 2,
            aarCollectionID: [1]
        }, () => {}, 0)

        // this.evaluateAnswerForSummative({
        //     text: '',
        //     isCorrect: true
        // }, {
        //     onOptionSelected: () => {},
        //     options: [
        //         {
        //             text: '',
        //             isCorrect: false
        //         },
        //         {
        //             text: '',
        //             isCorrect: true
        //         }
        //     ],
        //     aarScenarioID: 0,
        //     aarSectionID: 3,
        //     aarCollectionID: [1, 2, 3]
        // }, () => {}, 0)

        this.evaluateAnswerForSummative({
            text: '',
            isCorrect: false
        }, {
            onOptionSelected: () => {},
            options: [
                {
                    text: '',
                    isCorrect: false
                },
                {
                    text: '',
                    isCorrect: true
                }
            ],
            aarScenarioID: 1,
            aarSectionID: 0,
            aarCollectionID: [1]
        }, () => {}, 0)

        this.evaluateAnswerForSummativeStaffingPlan(4, 4, 4, 5, 0, 0, () => {});

        this.showAar(450, () => {alert('AAR Closed')});
	}

    public showAar(maxScore: number, onClose: () => void) {
        var context = this;
        var questions = this.gameManager.customData.saveData.scenarios[this.currentLevel].questions;
        var score = this.gameManager.customData.saveData.scenarios[this.currentLevel].scores[0];
        var percentage = Math.round((score / maxScore) * 100);
        set508Window(Window508Type.AARUI);
        context.gameManager.UiManager.createUIInstance(constants.uiNames.AARUI, {
            questions: questions,
            score: percentage,
            passed: percentage >= 80,
			onRetryClicked: () => {
                context.gameManager.customData.saveData.scenarios[this.currentLevel].lastPartId = null;
                context.gameManager.customData.saveGame(this.gameManager);
                window.location.reload();
            },
            onExitClicked: () => {
                context.gameManager.customData.updateWindow(Windows.MainMenu);
            }
		});
    }

    public evaluateAnswerForSummative(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig, onDone: () => void, levelPart: number): void {
        this._calculateScoring(selectedOption, levelPart, true);
        this.gameManager.customData.saveData.scenarios[this.currentLevel].questions.push({
            scenarioId: config.aarScenarioID,
            sectionId: config.aarSectionID,
            collectionId: config.aarCollectionID
        });
        this.gameManager.customData.saveGame(this.gameManager);
        //TODO: scoring
        onDone();
    }

    public evaluateAnswerForSummativeNurseStationComputerSingleQuestion(config: NurseStationComputerSingleQustionUIConfig, onDone: () => void): void {
        if(config.options[config.selectedOption].isCorrect) {
            CalmBaseScenario.scores[0] += 100;
        }
        this.gameManager.customData.saveData.scenarios[this.currentLevel].questions.push({
            scenarioId: config.aarScenarioID,
            sectionId: config.aarSectionID,
            collectionId: [config.selectedOption]
        });
        this.gameManager.customData.saveGame(this.gameManager);
        //TODO: scoring
        onDone();
    }

    public resetAAR(): void {
        for(var indx = 0; indx < this.gameManager.customData.saveData.scenarios.length; indx++) {
            this.gameManager.customData.saveData.scenarios[indx].questions = [];
        }
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public evaluateAnswerForSummativeStaffingPlan(chosenHeatherPatients: number, chosenMarcoPatients: number, chosenMirandaPatients: number, chosenBenPatients: number, chosenYouPatients: number, partIndx: number, onDone: () => void): void {

        CalmBaseScenario.scores[partIndx] += 100;

        this.gameManager.customData.saveData.scenarios[this.currentLevel].questions.push({
            chosenHeatherPatients: chosenHeatherPatients,
            chosenMarcoPatients: chosenMarcoPatients,
            chosenMirandaPatients: chosenMirandaPatients,
            chosenBenPatients: chosenBenPatients,
            chosenYouPatients: chosenYouPatients
        });
        this.gameManager.customData.saveGame(this.gameManager);
        //TODO: scoring
        onDone();
    }

    private showFeedback(feedback: string, onDone: () => void, tagExceptions?: string[]) {
        this.gameManager.UiManager.hideAllUis([]);
        var context = this;
        set508Window(Window508Type.GeneralAlertUI)
        const instanceId = this.gameManager.UiManager.createUIInstance(constants.uiNames.FeedbackUI, {
            text: feedback,
	        onContinueClicked: () => {
            set508Window(Window508Type.Main)
            context.gameManager.UiManager.destroyUIInstanceById(instanceId);
                onDone();
                context.gameManager.UiManager.showAllUis(tagExceptions ?? []);
            }
        })
    }
}